import React, { Component } from "react";
import { connect } from "react-redux";
import { Icon, Button } from "tabler-react";
import $ from "jquery";
import {
  Loader,
  DatePickerWithIcon,
  MultiSelect,
  NavigationBox,
} from "../../../../component";
import { Form } from "tabler-react";
import FilterResults from "./FilterResults";
import "./style.css";

import { mapActions } from "../../../../store/actions";
import { helper } from "../../../../utils/helpers/helper";
const defaultState = {
  id: null,
  value: null,
  label: null,
};
class MapFilterComponent extends Component {
  constructor(props) {
    super(props);
    this.recieveMeta = this.recieveMeta.bind(this);
  }
  state = {
    areaDisabled: true,
    districtClicked: false,
    areaClicked: false,
    startdate: null,
    enddate: null,
    keyword: null,
    area: defaultState,
    impact: defaultState,
    target: defaultState,
    attack: defaultState,
    attackers: defaultState,
    accuracy: defaultState,
    district: defaultState,
    impactData: [
      {
        id: 1,
        value: "low",
        label: "Low",
      },
      {
        id: 2,
        value: "medium",
        label: "Medium",
      },
      {
        id: 3,
        value: "high",
        label: "High",
      },
    ],
    accuracyData: [
      {
        id: 1,
        value: "low",
        label: "Low",
      },
      {
        id: 2,
        value: "medium",
        label: "Medium",
      },
      {
        id: 3,
        value: "high",
        label: "High",
      },
    ],
    selectElement: [],
  };

  getFilterResults = () => {
    this.props.openFilterSidebar(false, null);
    this.props.get(false);
    this.props.getFilterResults(this.state);
  };

  clearFilters = async (e) => {
    const { filterMetaData } = this.props;
    await this.setState(
      {
        startdate: null,
        enddate: null,
        keyword: null,
        area: defaultState,
        impact: defaultState,
        target: defaultState,
        attack: defaultState,
        attackers: defaultState,
        accuracy: defaultState,
        district: defaultState,
        selectElement: [],
      },
      () => {
        $("input[name=keyword]").val("");
        // do something after the stars are rendered
        this.recieveMeta(filterMetaData);
        this.props.clearMapFilters(true);
        this.props.openFilterSidebar(true, null);
      }
    );
    this.props.loadMapData();
  };

  getDate = (prop) => {
    const { name, date } = prop;
    this.setState({ [name]: date });
    const initialState = this.initialState;
    this.setState({ initialState });
  };

  async componentDidMount() {
    this.initialState = this.state;
    const { filterMetaData } = this.props;
    await this.recieveMeta(filterMetaData);
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleChangeSelect = async (prop) => {
    const { name, value } = prop;
    await this.setState({ [name]: value });
  };

  handleChildClick = async (prop) => {
    const { filterMetaData } = this.props;
    const { name, clicked } = prop;
    await this.setState({ [name]: clicked, areaDisabled: !clicked }, () => {
      // do something after the stars are rendered
      this.recieveMeta(filterMetaData);
    });

    //call api - distict/area
    // this.props.getAreas('Tripoli');
    if (this.state.district.value !== null) {
      this.props.getAreas(this.state.district.value);
    }
  };

  recieveMeta(filterMetaData) {
    const {
      impact,
      area,
      target,
      attack,
      attackers,
      accuracy,
      district,
      impactData,
      accuracyData,
      districtClicked,
      areaClicked,
      areaDisabled,
    } = this.state;
    let optionValue = "";
    if (!helper.isEmpty(filterMetaData)) {
      // Extract District data
      const districtData = [];
      const districtOptions = filterMetaData?.district;
      districtOptions &&
        districtOptions.map(function (obj, i) {
          optionValue = {
            id: obj?.id,
            value: !helper.isEmpty(obj?.name) ? obj?.name.toLowerCase() : "",
            label: obj?.name,
          };
          districtData.push(optionValue);
          return null;
        });
      // Extract District data
      const areaData = [];
      const areaOptions = filterMetaData?.area;
      areaOptions &&
        areaOptions.map(function (obj, i) {
          optionValue = {
            id: obj?.id,
            value: !helper.isEmpty(obj?.name) ? obj?.name.toLowerCase() : "",
            label: obj?.name,
          };
          areaData.push(optionValue);
          return null;
        });
      // Extract Atatck data
      const attackData = [];
      const attackOptions = filterMetaData?.attack;
      attackOptions &&
        attackOptions.map(function (obj, i) {
          optionValue = {
            id: obj?.id,
            value: !helper.isEmpty(obj?.name) ? obj?.name.toLowerCase() : "",
            label: obj?.name,
          };
          attackData.push(optionValue);
          return null;
        });
      // Extract Atatcker data
      const attackersData = [];
      const attackersOptions = filterMetaData?.attackers;
      attackersOptions &&
        attackersOptions.map(function (obj, i) {
          optionValue = {
            id: obj?.id,
            value: !helper.isEmpty(obj?.name) ? obj?.name.toLowerCase() : "",
            label: obj?.name,
          };
          attackersData.push(optionValue);
          return null;
        });
      // Extract Target data
      const targetData = [];
      const targetOptions = filterMetaData?.target;
      targetOptions &&
        targetOptions.map(function (obj, i) {
          optionValue = {
            id: obj?.id,
            value: !helper.isEmpty(obj?.name) ? obj?.name.toLowerCase() : "",
            label: obj?.name,
          };
          targetData.push(optionValue);
          return null;
        });
      const select = [
        {
          name: "district",
          placeholder: "District",
          options: districtData,
          disabled: false,
          clicked: districtClicked,
          handler: this.handleChangeSelect,
          clickHandler: this.handleChildClick,
          value: !helper.isEmpty(district)
            ? district?.value !== null
              ? district
              : []
            : [],
        },
        {
          name: "area",
          placeholder: "Area",
          options: areaData,
          disabled: areaDisabled,
          clicked: areaClicked,
          handler: this.handleChangeSelect,
          clickHandler: this.handleChildClick,
          value: !helper.isEmpty(area)
            ? area?.value !== null
              ? area
              : []
            : [],
        },
        {
          name: "attack",
          placeholder: "Attack Type",
          options: attackData,
          disabled: false,
          clicked: null,
          handler: this.handleChangeSelect,
          clickHandler: this.handleChildClick,
          value: !helper.isEmpty(attack)
            ? attack?.value !== null
              ? attack
              : []
            : [],
        },
        {
          name: "attackers",
          placeholder: "Attacker",
          options: attackersData,
          disabled: false,
          clicked: null,
          handler: this.handleChangeSelect,
          clickHandler: this.handleChildClick,
          value: !helper.isEmpty(attackers)
            ? attackers?.value !== null
              ? attackers
              : []
            : [],
        },
        {
          name: "accuracy",
          placeholder: "Accuracy",
          options: accuracyData,
          disabled: false,
          clicked: null,
          handler: this.handleChangeSelect,
          clickHandler: this.handleChildClick,
          value: !helper.isEmpty(accuracy)
            ? accuracy?.value !== null
              ? accuracy
              : []
            : [],
        },
        {
          name: "impact",
          placeholder: "Impact",
          options: impactData,
          disabled: false,
          clicked: null,
          handler: this.handleChangeSelect,
          clickHandler: this.handleChildClick,
          value: !helper.isEmpty(impact)
            ? impact?.value !== null
              ? impact
              : []
            : [],
        },
        {
          name: "target",
          placeholder: "Target",
          options: targetData,
          disabled: false,
          clicked: null,
          handler: this.handleChangeSelect,
          clickHandler: this.handleChildClick,
          value: !helper.isEmpty(target)
            ? target?.value !== null
              ? target
              : []
            : [],
        },
      ];
      this.setState({ selectElement: select }, () => {
        this.forceUpdate();
      });
    }
    return this.state;
  }

  async componentWillReceiveProps(nextProps, nextState) {
    const { filterMetaData, getAreasData } = nextProps;
    if (this.props.clearFilters !== nextProps.clearFilters) {
      await this.recieveMeta(filterMetaData);
    }
    if (
      this.props.filterMetaData !== nextProps.filterMetaData &&
      !helper.isEmpty(filterMetaData)
    ) {
      await this.recieveMeta(filterMetaData);
    }
    if (nextProps.filter === true && nextProps.clearFilters === false) {
      await this.recieveMeta(filterMetaData);
    }
    // if (nextProps.clearFilters === true) {
    //   await this.setState({
    //     startdate: null,
    //     enddate: null,
    //     keyword: null,
    //   });
    // }
    if (!helper.isEmpty(getAreasData.length)) {
      filterMetaData.area = getAreasData;
      await this.recieveMeta(filterMetaData);
    }
  }

  render() {
    const {
      startdate,
      enddate,
      selectElement,
      district,
      impact,
      target,
      attack,
      attackers,
      accuracy,
      keyword,
    } = this.state;
    const {
      filter,
      filterData,
      dataLoading,
      recordCount,
      totalRecordCount,
      show,
    } = this.props;
    return (
      <>
        {show &&
        (startdate ||
          enddate ||
          district ||
          impact ||
          target ||
          attack ||
          attackers ||
          accuracy ||
          keyword) ? (
          <NavigationBox data-tut="sidebarBtn">
            <div id="mapFilters">
              {/* {filterMetaError !== "" ? <: ''} */}
              <Form.Group className="mb-2 col col-xs-12 col-sm-12 col-md-12 col-lg-12 searchByKeyword">
                <Form.Input
                  type="text"
                  name="keyword"
                  className="mb-2 "
                  id="keyword"
                  // error={errors && errors.old_pwd}
                  onChange={this.handleChange}
                  value={keyword}
                  placeholder="Search by keyword"
                />
              </Form.Group>
              <DatePickerWithIcon
                txt="Start Date"
                getDate={this.getDate}
                name="startdate"
                value={startdate}
              />
              <DatePickerWithIcon
                txt="End Date"
                getDate={this.getDate}
                name="enddate"
                value={enddate}
                min={startdate}
              />
              {(district ||
                impact ||
                target ||
                attack ||
                attackers ||
                accuracy) &&
                selectElement &&
                selectElement.map(function (element, i) {
                  return (
                    <MultiSelect
                      key={i}
                      onChange={element.handler}
                      className="mb-2 ml-3 mr-5"
                      name={element.name}
                      isClicked={element.clicked}
                      options={element.options}
                      isDisabled={element.disabled}
                      onClick={element.clickHandler}
                      isMultiple={false}
                      value={element.value}
                      placeholder={element.placeholder}
                    />
                  );
                })}
              <div className="float-right">
                {filter === true ? (
                  <Button
                    color="primary"
                    className="ml-2 float-left mr-4"
                    onClick={this.clearFilters}
                  >
                    Clear All Filters <Icon prefix="fe" name="x-circle" />
                  </Button>
                ) : (
                  ""
                )}
                <button
                  className="btn btn-primary mr-5"
                  onClick={this.getFilterResults}
                >
                  Go <Icon prefix="fe" name="arrow-right-circle" />
                </button>
              </div>
            </div>
          </NavigationBox>
        ) : dataLoading && filter !== false ? (
          <Loader image="data-loading" />
        ) : (
          <FilterResults
            data={filterData}
            minRecord={recordCount}
            maxRecord={totalRecordCount}
            clearFilters={this.clearFilters}
          />
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  // const { filterRecords, impact, target, attack, attacker, type_of_attack, accuracy, district, city  } = state.map; return { filterRecords };
  const {
    filter,
    filterData,
    filterMetaData,
    dataLoading,
    recordCount,
    totalRecordCount,
    clearFilters,
    getAreasData,
  } = state.map;
  return {
    alert,
    filter,
    filterData,
    filterMetaData,
    dataLoading,
    recordCount,
    totalRecordCount,
    clearFilters,
    getAreasData,
  };
}

const mapDispatchToProps = {
  clearAlerts: mapActions.clear,
  loadMapData: mapActions.loadMapData,
  clearMapFilters: mapActions.clearMapFilters,
  getFilterResults: mapActions.getFilterResults,
  openFilterSidebar: mapActions.openFilterSidebar,
  getAreas: mapActions.getAreas,
};

export default connect(mapStateToProps, mapDispatchToProps)(MapFilterComponent);
